import React, { useContext, useState } from "react";
import { Form, Formik } from 'formik';
import { observer } from "mobx-react-lite";
import { CampaignContactSchema } from "../../../../../../schemas/CampaignContactSchema";
import CampaignContact from "../../../../../../models/CampaignContact";
import Modal from "../../../../../Modal/Modal";
import Input from "../../../../../FormComponents/Input";
import axiosService from "../../../../../../utils/AxiosService";
import { toastError, toastSuccess } from "../../../../../FormComponents/Toasts";
import { CampaignContext } from "../../../../../../contexts/CampaignContext";
import FileDropzone from "../../../../../FormComponents/FileDropzone";
import { FileEarmarkPlus, ArrowLeft, Trash } from "react-bootstrap-icons";
import PhoneField from "../../../../../FormComponents/PhoneField";

export default observer(function CampaignContactModal({ isOpen, setIsOpen, edit, editableContact, index }) {
  const { campaignContacts, campaign } = useContext(CampaignContext)
  const [src, setSrc] = useState(null)

  const onSubmit = campaignContact => {
    const formData = new FormData()
    formData.append('campaign_contact[name]', campaignContact.name)
    formData.append('campaign_contact[email]', campaignContact.email)
    formData.append('campaign_contact[phone]', campaignContact.phone)
    formData.append('campaign_contact[notes]', campaignContact.notes)
    if(campaignContact.file) formData.append('campaign_contact[avatar]', campaignContact.file)

    const submitFunction = edit ? updateContact : createContact
    submitFunction(formData)
    .then(() => {
      setSrc(null)
      setIsOpen(false)
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  const updateContact = formData => {
    return axiosService.patch(`/api/project_manager/campaigns/${campaign.id}/campaign_contacts/${editableContact.id}`, formData,  { headers: { "Content-type": "multipart/form-data" } })
    .then((updatedCampaignContact) => {
      campaignContacts.splice(index, 1, updatedCampaignContact)
      toastSuccess('Contact Updated')
    })
  }

  const createContact = formData => {
    return axiosService.post(`/api/project_manager/campaigns/${campaign.id}/campaign_contacts/`, formData,  { headers: { "Content-type": "multipart/form-data" } })
    .then(newCampaignContact => {
      campaignContacts.push(newCampaignContact)
      toastSuccess('Contact Created')
    })
  }

  const deleteContact = () => {
    return axiosService.delete(`/api/project_manager/campaigns/${campaign.id}/campaign_contacts/${editableContact.id}`)
    .then((oldContact) => {
      campaignContacts.splice(campaignContacts.findIndex(contact => contact.id === oldContact.id), 1)
      toastSuccess('Contact Removed')
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className="w-96 h-[600px] overflow-y-auto pb-4 dark:bg-rb-dark-mode">
        <Modal.Body>
          <Modal.Header>
            <h2 className="dark:text-white">{edit ? 'Update Contact' : 'Create New Contact'}</h2>
          </Modal.Header>
            <Formik
              initialValues={new CampaignContact(editableContact)}
              validationSchema={CampaignContactSchema}
              onSubmit={onSubmit}
            >
              {({ handleBlur, handleChange, values, touched, errors, setFieldValue }) => (
                <Form>
                  <div className="w-full">

                    <Input error={touched.name && errors.name} noLabelPadding label="Name" placeholder="Name" name='name' onChange={handleChange} onBlur={handleBlur} value={values.name} />
                    <Input error={touched.email && errors.email} noLabelPadding label="E-mail address" placeholder="Email" name="email" onChange={handleChange} onBlur={handleBlur} value={values.email} />
                    <PhoneField error={touched.phone && errors.phone} noLabelPadding label="Phone number" name='phone' onChange={value => setFieldValue('phone', value, true)} onBlur={handleBlur} value={values.phone} />
                      <div className={`w-full flex justify-center ${values.avatar?.url && 'py-6' || 'py-1'}`}>
                        {values.avatar?.url && <img className="h-20 w-20 rounded-3xl" src={values.avatar.url} />}
                      </div>
                    <span className="label dark:text-white">Note</span>
                    <textarea
                      name='notes'
                      placeholder="Write a note"
                      rows="4"
                      cols="40"
                      className='
                        mb-4
                        border-1
                        border-rb-lite-grey
                        dark:border-rb-dark-mode-lighter
                        dark:bg-rb-dark-mode
                        dark:text-white
                        dark:placeholder-gray-400
                        focus-visible:outline-0
                        focus-visible:border-rb-green
                        focus-visible:border-2
                        focus:outline-0
                        focus:ring-transparent
                        focus:ring-offset-transparent
                        ring-transparent
                        ring-offset-transparent
                        rounded-lg
                        w-full'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.notes}
                      error={touched.notes && errors.notes}
                    />
                    <span className="label dark:text-white">Contact Avatar</span>
                    <FileDropzone uploadFiles={files => {
                        setSrc(URL.createObjectURL(files[0]))
                        setFieldValue('file', files[0])
                      }}
                      icon={<FileEarmarkPlus />}
                    />
                    <div className={`w-full flex justify-center ${src && 'py-6' || 'py-1'}`}>
                      {src && <img className="h-20 w-20 rounded-3xl" src={src} />}
                    </div>
                    <div className="flex justify-between mt-5">
                      <button
                        className={`${edit ? '' : 'hidden '}flex items-center dark:text-white`}
                        onClick={() => {
                          deleteContact()
                          setIsOpen(false)
                        }}
                      >
                        <Trash />
                        <span className="ml-1">Delete contact</span>
                      </button>
                      <button
                        type="submit"
                        className={`${edit ? '' : 'ml-auto '}submit text-white bg-rb-green border-2 rounded-lg px-4 py-2 text-center active:shadow-outer active:shadow-rb-green border-rb-green`}
                      >
                        {edit ? 'Update Contact' : 'Create Contact'}
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </div>
    </Modal>
  );
})

